export const MOCK_DATA: Record<string, any>[] = [
  {
    "id": "52a1e78b-bedd-40fc-a79d-3ce0deab9fb3",
    "bundle_organization_attribution_guid": "d7036f4e-b5d2-42d0-8ac8-db6cce21ee7f",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T05:34:14.301Z",
    "bundle_id": "caa1c8fa-2497-4560-b8d4-8d2be56ccea9",
    "organization_attribution_id": "ade979ca-0289-4811-a4c7-556a28273564"
  },
  {
    "id": "0d94c61a-2653-4217-bbdd-65eff37048f1",
    "bundle_organization_attribution_guid": "8f2e58e2-03e2-487e-a2bf-dc1d85738349",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T05:34:14.301Z",
    "bundle_id": "caa1c8fa-2497-4560-b8d4-8d2be56ccea9",
    "organization_attribution_id": "f40814d8-9f72-4e36-85a0-0ccb137533c1"
  },
  {
    "id": "d0cb7cae-4577-438b-9758-1569307b3c75",
    "bundle_organization_attribution_guid": "db923eca-d85b-45a6-be65-76a42d6451e6",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T05:34:14.301Z",
    "bundle_id": "caa1c8fa-2497-4560-b8d4-8d2be56ccea9",
    "organization_attribution_id": "72a3e781-678c-4a41-a27e-a3d876f9d525"
  },
  {
    "id": "84c469ce-c7a4-4758-a46f-798dbade455a",
    "bundle_organization_attribution_guid": "cc057bfb-cdd4-4ade-86ce-6dc0cfe31c30",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T05:34:14.302Z",
    "bundle_id": "caa1c8fa-2497-4560-b8d4-8d2be56ccea9",
    "organization_attribution_id": "8094c98a-9f43-481c-8a58-f638e25027e7"
  },
  {
    "id": "2d22349c-750e-4e8b-bc2e-3c94db3cb849",
    "bundle_organization_attribution_guid": "2e366aed-a081-4d6a-ad42-eeb6b7cc0dd1",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T05:34:14.302Z",
    "bundle_id": "caa1c8fa-2497-4560-b8d4-8d2be56ccea9",
    "organization_attribution_id": "67702c56-5067-4c14-a22f-e5efe8796c6a"
  },
  {
    "id": "db3fa986-a4d4-4f1d-aba5-39237d0dd4a6",
    "bundle_organization_attribution_guid": "268e97c5-6aee-4779-aedd-8e12409e8a12",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T05:34:14.302Z",
    "bundle_id": "caa1c8fa-2497-4560-b8d4-8d2be56ccea9",
    "organization_attribution_id": "94e704ee-a491-4158-8ef9-822a9f450145"
  }
];